import { render, staticRenderFns } from "./CreateTestCase.vue?vue&type=template&id=f45d14a4&scoped=true&"
import script from "./CreateTestCase.vue?vue&type=script&lang=js&"
export * from "./CreateTestCase.vue?vue&type=script&lang=js&"
import style0 from "./CreateTestCase.vue?vue&type=style&index=0&id=f45d14a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45d14a4",
  null
  
)

export default component.exports